import CSCPTable from "../cscp-table"

export default class JobPostingReport extends CSCPTable {
    constructor() {
        super();
    }

    initSettings() {

        this.instance = "cscpjs.default.jobpostingReportjs";
        this.method = "/Reports/JobPostingPaging";
        this.tableId = "jobpostingTable";

        this.columns = [
            { data: "Title", class: "column-quarter" },
            { data: "Description", class: "column-quarter" },
            {
                customContent: (row) => {
                    const part = row.PostingStartDate.split("(")[1].split(")")[0];
                    return new Date(parseInt(part)).toDateString();
                }, class: "column-quarter"
            },
            { data: "PostingLength", class: "column-quarter" },
            {
                customContent: (row) => {
                    return `<a onclick="cscpjs.default.tablesjs.openUrlNewTab('DownloadFiles','FileDownload','?user=${this.additionalAttr.user}&hash=${this.additionalAttr.hash}&id=${row.ID}')">
                                ${this.additionalAttr.downloadLabel}
                            </a>`
                }, class: "column-quarter-last"
            }
        ]
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/jobpostingReport.js